var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconAnalyticsWhite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-analytics",
    width: 36.05,
    height: 36.05,
    viewBox: "0 0 36.05 36.05",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1823",
    "data-name": "Group 1823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10430",
    "data-name": "Path 10430",
    d: "M10.012,2a9.012,9.012,0,1,0,9.012,9.012A9.012,9.012,0,0,0,10.012,2ZM4,11.012A6.008,6.008,0,0,1,15.83,9.51H8.51v7.32A6.017,6.017,0,0,1,4,11.012Zm7.51,5.818V12.515H15.83A6.024,6.024,0,0,1,11.515,16.83Zm-3,7.7h3v7.51h-3Zm7.51-3h3V32.042h-3ZM23.531,9.51h3V32.042h-3Zm7.51,6.008h3V32.042h-3Z",
    transform: "translate(0.502 1.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10431",
    "data-name": "Path 10431",
    d: "M0,0H36.05V36.05H0Z",
    fill: "none",
    fillRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconAnalyticsWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-analytics-white.65361c0b.svg";
export { ForwardRef as ReactComponent };